import React from "react";

import RSCard from "./RSCard";
import ThisTheme from "../../../themes/RSTheme";

function RSWidget() {
    return (
        <React.Fragment>
            <RSCard theme={ThisTheme} />
        </React.Fragment>
    );
}

export default RSWidget;
